import React, {useState, useEffect} from 'react'
import InsButton from '../../../../components/InsButton/InsButton'
import { withTranslation } from 'react-i18next'
import { Link } from "react-router-dom"
import images from '../../../../ressources/images';
import './ShopValidation.scss'

const ShopValidation = (props) => {
  const [contentHeight, setContentHeight] = useState(window.innerHeight)
  const {t} = props
  const orderNbr = props.match.params.number
  // let contentStyle = {height: contentHeight - 120}

  const updateDimensions = () => {
    setContentHeight(window.innerHeight)
  }
  
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
  }, [contentHeight])

  return (
    <div>
      {/* <InsHeader/> */}
      <div className="order_validation_page">
        <div className="order_confirm">
          {t('order_confirm')}
        </div>
        <div className="order_confirm_img">
          <img src={images.order_confirm} alt={t('order_confirm')}/>
        </div>
        <div className="order_register">
          {t('order_register')}
        </div>
        <div className="order_tracking">
          {t('order_Number_Label')} :<br/>
          {t('order_number')} {orderNbr}
        </div>
        <Link to={{ pathname: '/shop', state: { transitionName: "slide_out" }}}>
          <InsButton
            text={t('back_home')}
          />
        </Link>
      </div>
      {/* <InsNavigation/> */}
    </div>
  )
}

export default withTranslation()(ShopValidation)
